function isMobileDevice() {
  if (typeof window === "undefined") {
    return false; // 非浏览器环境直接返回false
  }

  const userAgent = window.navigator.userAgent.toLowerCase();

  // 常见移动设备关键词
  const mobileKeywords = [
    "mobile",
    "android",
    "ios",
    "iphone",
    "ipad",
    "ipod",
    "windows phone",
  ];

  // 检测userAgent是否包含移动设备关键词
  return mobileKeywords.some((keyword) => userAgent.includes(keyword));
}

function handleResize() {
  const isMobile = isMobileDevice();
  if (isMobile) {
    // 移动端逻辑
    const origin = location.origin;
    if (origin.includes("localhost")) {
      location.href = `http://localhost:3001${location.pathname}${location.search}`;
    } else if (origin.includes("devplus")) {
      location.href = `https://devh5plus.funchodata.com${location.pathname}${location.search}`;
    } else if (origin.includes("test")) {
      location.href = `https://testh5.funchodata.com${location.pathname}${location.search}`;
    } else {
      location.href = `https://h5.funchodata.com${location.pathname}${location.search}`;
    }
  } else {
    // web端加载main.ts
    import("@/main")
      .then((module) => {
        // 假设main.ts导出了默认函数，执行它
        (module as any).default?.();
      })
      .catch((error) => {
        console.error("加载main.ts失败:", error);
      });
  }
}

handleResize();
window.addEventListener("resize", handleResize);
